import { AppError } from "./errors";

export async function wait(ms: number, signal?: AbortSignal) {
    return await new Promise<void>((resolve, reject) => {
        if (signal?.aborted) {
            reject(new AppError("Wait aborted", { code: "canceled" }));
            return;
        }

        const timeoutId = window.setTimeout(() => {
            signal?.removeEventListener("abort", onAbort);
            resolve();
        }, ms);

        if (!signal) {
            return;
        }
        const onAbort = () => {
            window.clearTimeout(timeoutId);
            signal.removeEventListener("abort", onAbort);
            reject(new AppError("Wait aborted", { code: "canceled" }));
        };

        signal.addEventListener("abort", onAbort, { once: true });
    });
}
